"use strict";

var _ = require("lodash");

module.exports = /* @ngInject */ function($q, $log, openFinApi) {
  var that = this;

  that.create = function(options) {
    return openFinApi.getFin().then(function(fin) {
      return $q(function(resolve, reject) {
        var openFinWindow = new fin.desktop.Window(
          options,
          function() {
            resolve(openFinWindow);
          },
          reject
        );
      });
    });
  };

  that.getBounds = function(openFinWindow) {
    return $q(function(resolve, reject) {
      openFinWindow.getBounds(resolve, reject);
    });
  };

  that.setBounds = function(openFinWindow, left, top, width, height) {
    if (_.isObject(left)) {
      var bounds = left;
      left = bounds.left;
      top = bounds.top;
      width = bounds.width;
      height = bounds.height;
    }
    return $q(function(resolve, reject) {
      openFinWindow.setBounds(
        left,
        top,
        width,
        height,
        function() {
          resolve(openFinWindow);
        },
        reject
      );
    });
  };

  that.getState = function(openFinWindow) {
    return $q(function(resolve, reject) {
      openFinWindow.getState(resolve, reject);
    });
  };

  that.setState = function(openFinWindow, state) {
    if (state === "minimized") {
      return that.minimize(openFinWindow);
    } else if (state === "maximized") {
      return that.maximize(openFinWindow);
    }
    return that.restore(openFinWindow);
  };

  that.restore = function(openFinWindow) {
    // Normal restore fails when there is a switch in the monitor configuration(one of the monitors is taken down)
    // Openfin library is supposed to automatically restore to the primary window in this case, but does not work
    // validated that this is not happening because the 'restore' notificaiton fails to be notified.
    // as a workaround, minimizing and then restoring the window. This does not have a side effect on the final state.
    return that.minimize(openFinWindow).then(
      function(openFinWindow) {
        return $q(function(resolve, reject) {
          openFinWindow.restore(
            function() {
              resolve(openFinWindow);
            },
            function(reason) {
              $log.error("Error restoring window: " + reason);
              reject(reason);
            }
          );
        });
      },
      function(error) {
        $q.reject(error);
      }
    );
  };

  that.minimize = function(openFinWindow) {
    return $q(function(resolve, reject) {
      openFinWindow.minimize(
        function() {
          resolve(openFinWindow);
        },
        function(reason) {
          $log.error("Error minimizing window: " + reason);
          reject(reason);
        }
      );
    });
  };

  that.maximize = function(openFinWindow) {
    return $q(function(resolve, reject) {
      openFinWindow.maximize(
        function() {
          resolve(openFinWindow);
        },
        function(reason) {
          $log.error("Error maximizing window: " + reason);
          reject(reason);
        }
      );
    });
  };

  that.restoreIfMinimized = function(openFinWindow) {
    return that.getState(openFinWindow).then(function(state) {
      if (state === "minimized") {
        return that.restore(openFinWindow);
      } else {
        return openFinWindow;
      }
    });
  };

  that.getNativeId = function(openFinWindow) {
    return $q(function(resolve, reject) {
      return openFinWindow.getNativeId(function(nativeId) {
        resolve(parseInt(nativeId, 16));
      }, reject);
    });
  };

  that.show = function(openFinWindow) {
    return isShowing(openFinWindow)
      .then(function(isShowing) {
        if (!isShowing) {
          return showWhilePreservingState(openFinWindow);
        }
      })
      .then(function() {
        return that.setAsForeground(openFinWindow);
      })
      .catch(function(reason) {
        $log.error("Error showing window: " + reason);
      });
  };

  function isShowing(openFinWindow) {
    return $q(function(resolve, reject) {
      openFinWindow.isShowing(resolve, reject);
    });
  }

  function showWhilePreservingState(openFinWindow) {
    return that.getState(openFinWindow).then(function(state) {
      if (state === "maximized") {
        return showMaximized(openFinWindow);
      } else {
        return justShow(openFinWindow);
      }
    });
  }

  function showMaximized(openFinWindow) {
    return justShow(openFinWindow).then(function() {
      /* openFinWindow.show() will restore maximized window to normal state.
       * Maximize the window again after it's shown so that the window stays maximized.
       * */
      return that.maximize(openFinWindow);
    });
  }

  function justShow(openFinWindow) {
    return $q(function(resolve, reject) {
      openFinWindow.show(
        true,
        function() {
          resolve(openFinWindow);
        },
        reject
      );
    });
  }

  that.setAsForeground = function(openFinWindow) {
    return $q(function(resolve, reject) {
      openFinWindow.setAsForeground(function() {
        resolve(openFinWindow);
      }, reject);
    });
  };

  that.close = function(openFinWindow, force) {
    return $q(function(resolve, reject) {
      openFinWindow.close(
        force,
        function() {
          resolve(openFinWindow);
        },
        reject
      );
    });
  };

  that.executeJavaScript = function(openFinWindow, code) {
    return $q(function(resolve, reject) {
      openFinWindow.executeJavaScript(
        code,
        function() {
          resolve(openFinWindow);
        },
        reject
      );
    });
  };

  that.getLayout = function(openFinWindow) {
    return $q
      .all([that.getBounds(openFinWindow), that.getState(openFinWindow)])
      .then(function(results) {
        var bounds = results[0];
        var state = results[1];

        return {
          left: bounds.left,
          top: bounds.top,
          height: bounds.height,
          width: bounds.width,
          state: state
        };
      });
  };
};



// WEBPACK FOOTER //
// ./app/infrastructure/utils/openFinWindowUtils.js